export enum ModuleType {
  LITE = 'LITE',
  BASE = 'BASE',
  GEO = 'GEO',
  'GEO-REMOVED' = 'GEO-REMOVED',
  LEO = 'LEO',
  TIMESHARE = 'TIMESHARE',
}
